var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinistriesKadap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.894,
    height: 23.903,
    viewBox: "0 0 22.894 23.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-306.955 -149.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1_-_Outline",
    "data-name": "Polygon 1 - Outline",
    d: "M15.594,1.71,6.162,8.321H25.026L15.594,1.71m0-1.237a.813.813,0,0,1,.467.146L26.712,8.085a.761.761,0,0,1-.467,1.383H4.942a.761.761,0,0,1-.467-1.383L15.127.619A.813.813,0,0,1,15.594.473Z",
    transform: "translate(302.808 149.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M-.927,6.529A.573.573,0,0,1-1.5,5.955V-.927A.573.573,0,0,1-.927-1.5a.573.573,0,0,1,.573.573V5.955A.573.573,0,0,1-.927,6.529Z",
    transform: "translate(311.614 162.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M-.927,6.529A.573.573,0,0,1-1.5,5.955V-.927A.573.573,0,0,1-.927-1.5a.573.573,0,0,1,.573.573V5.955A.573.573,0,0,1-.927,6.529Z",
    transform: "translate(327.035 162.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M-.927,6.529A.573.573,0,0,1-1.5,5.955V-.927A.573.573,0,0,1-.927-1.5a.573.573,0,0,1,.573.573V5.955A.573.573,0,0,1-.927,6.529Z",
    transform: "translate(319.325 162.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16_-_Outline",
    "data-name": "Rectangle 16 - Outline",
    d: "M1.986,1.147a.781.781,0,0,0-.794.765.781.781,0,0,0,.794.765h18.27a.781.781,0,0,0,.794-.765.781.781,0,0,0-.794-.765H1.986M1.986,0h18.27a1.95,1.95,0,0,1,1.986,1.912,1.95,1.95,0,0,1-1.986,1.912H1.986A1.95,1.95,0,0,1,0,1.912,1.95,1.95,0,0,1,1.986,0Z",
    transform: "translate(307.281 170.061)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinistriesKadap);
export default __webpack_public_path__ + "static/media/ministries_kadap.51328061.svg";
export { ForwardRef as ReactComponent };